export const formatProfessionAnesthesie = rawData => {
  const formattedData = [];

  rawData.forEach(item => {
    formattedData.push({
      key: `item-${item.id}`,
      value: item.id,
      dataValue: item.id,
      label: item.libelle
    });
  });

  return formattedData;
};

export const formatPraticiensAnesthesie = rawData => {
  const formattedData = [];

  rawData.forEach(item => {
    formattedData.push({
      key: `item-${item.id_chirurgien}`,
      value: item.id_chirurgien,
      dataValue: item.identifiant_arbre_profession_entite
        ? item.identifiant_arbre_profession_entite
        : item.identifiant_sequence_defaut,
      label: `${item.nom} ${item.prenom}`
    });
  });

  return formattedData;
};

export const formatQuestion = rawData => {
  const formattedData = [];

  rawData.forEach(item => {
    formattedData.push({
      key: `item-${item.val}`,
      value: item.val,
      dataValue: item.val,
      label: item.text,
      openUpload: item.openupload,
      typeReponse: item.typereponse,
      listResponse: item.tablist,
      responseId: item.idreponse,
      paramName: item.nomvariable
    });
  });

  return formattedData;
};

export const formatAppointmentOld = rawData => {
  const formattedData = [];
  rawData.forEach(item => {
    formattedData.push({
      key: item.id,
      label: item.medecin,
      appointment: `${item.date} à ${item.heureaff_patient}`,
      avatar: item.link_avatar,
      date: item.dateaff,
      isRequiredPayment: item.rdvpaiement,
      nomDocteurRefPrinc:
        item.activ_remplacant === "ok" ? item.nom_docteur_ref_princ : "",
      practitionerName: item.civilite + " " + item.nom_docteur_ref
    });
  });

  return formattedData;
};

export const formatAppointmentList = rawData => {
  const formattedData = [];
  rawData.forEach(item => {
    const parsedId = item.id.split("-");
    const locationId = parsedId[6];
    const appointmentType = parsedId[8];
    formattedData.push({
      key: item.id,
      label: item.medecin,
      appointment: `${item.date} à ${item.heureaff_patient}`,
      avatar: item.link_avatar,
      date: item.dateaff,
      isRequiredPayment: item.rdvpaiement,
      rdvHelp:
        item.infordvaide && item.infordvaide.decoupe_rdvfils
          ? item.infordvaide.decoupe_rdvfils
          : "",
      nomDocteurRefPrinc:
        item.activ_remplacant === "ok"
          ? item.nom_abrev_civi_ref + " " + item.nom_docteur_ref
          : "",
      practitionerId: item?.id_long,
      locationId: locationId,
      appointmentTypeId: appointmentType,
      practitionerName: item.civilite + " " + item.nom_docteur_ref
    });
  });

  return formattedData;
};

export const formatWaitingRoomPersons = (data, isInWaitingRoom = false) => {
  const formattedData = [];
  data.forEach(item => {
    formattedData.push({
      appointmentId: item.identification_rdv,
      firstName: item.nompatient,
      lastName: item.prenompatient,
      userId: item.iddpatient,
      nameRoom: item.nom_salle,
      pictureRoom: item.image_salle,
      isInWaitingRoom: isInWaitingRoom,
      civilityDoctor: item.civilitedocteur,
      firstNameDoctor: item.nom_praticien
    });
  });
  return formattedData;
};

export const formatWaitingRoomPersonsExternal = data => {
  const formattedData = [];
  data.forEach(item => {
    formattedData.push({
      id: item.id,
      firstName: item.nom,
      lastName: item.prenom,
      nameRoom: item.message_salle,
      pictureRoom: item.imagePlan,
      keyMikjaki: item.keymikajaki,
      urlMokajai: item.urlmokajai
    });
  });
  return formattedData;
};

export const formatAppointment = (rawData, date) => {
  let formattedData = [...new Array(7).keys()];
  formattedData.forEach((item, key) => {
    const currentDate = date.plus({ days: key });
    formattedData[key] = {
      formattedDate: currentDate,
      weekDay: currentDate.weekdayLong,
      date: `${currentDate.get("day")} ${currentDate.get("monthShort")}`,
      list: rawData[currentDate.setLocale("fr").toFormat("dd/LL/yyyy")] || [],
      success: 1
    };
  });
  return formattedData;
};

export const formatNoAppointment = (json, date) => {
  json = json[0];
  let formattedData = [...new Array(7).keys()];
  formattedData.forEach((item, key) => {
    const currentDate = date.plus({ days: key });
    formattedData[key] = {
      weekDay: currentDate.weekdayLong,
      date: `${currentDate.get("day")} ${currentDate.get("monthShort")}`,
      message: json.messagealert,
      dateToShow: json.dateaffiche || null,
      nextDate: json.date || null,
      formattedDate: currentDate,
      success: 0
    };
  });
  return formattedData;
};

export const formatProfessionalType = rawData => {
  const formattedData = [];

  rawData.liste.forEach(item => {
    formattedData.push({
      key: `item-${item.id}`,
      value: item.id,
      dataValue: item.nombre,
      label: item.libelle,
      avatar: item.img
    });
  });

  return formattedData;
};

export const formatProfession = rawData => {
  const formattedData = [];
  if (!rawData.success || rawData.success !== 1 || !rawData.liste) {
    return formattedData;
  }
  rawData.liste.forEach(item => {
    formattedData.push({
      key: `item-${item.id}`,
      value: item.id,
      dataValue: item.id,
      label: item.libelle
    });
  });

  return formattedData;
};

export const formatAppointmentType = rawData => {
  const formattedData = [];
  if (rawData.success && rawData.success === "nop") {
    return formattedData;
  }
  rawData.forEach(item => {
    formattedData.push({
      key: `item-${item.id}`,
      value: item.id,
      dataValue: item.id,
      label: item.libelle,
      sequence2: item.sequence_2
    });
  });

  return formattedData;
};

export const formatAppointmentLocation = rawData => {
  const formattedData = [];

  rawData.forEach(item => {
    formattedData.push({
      key: `item-${item.id}`,
      value: item.id,
      dataValue: item.sel,
      label: item.libelle
    });
  });

  return formattedData;
};

export const formatPractitioner = rawData => {
  const formattedData = [];

  rawData.forEach(item => {
    formattedData.push({
      key: `item-${item.id}`,
      value: item.id,
      dataValue: item.id,
      label: item.libelle,
      avatar: item.img
    });
  });

  return formattedData;
};

export const formatNbPeople = rawData => {
  const formattedData = [];
  // rawData = {"1":1,"2":2,"3":3}
  rawData = Object.values(rawData); //
  rawData.forEach(item => {
    formattedData.push({
      key: `item-${item}`,
      value: item,
      dataValue: item,
      label: item
    });
  });

  return formattedData;
};
